module.exports = __webpack_public_path__ + "static/media/welcome_poster_image.dc2044c2.jpg";